// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text___T_c9","chevron":"styles_chevron__iP5O3","skeleton-animation":"styles_skeleton-animation__zG8Gj"};